import {
    mdiAccountCircle,
    mdiPlus,
    mdiAlarm,
    mdiApi,
    mdiArrowLeft,
    mdiAspectRatio,
    mdiBookOpenPageVariant,
    mdiBullhornOutline,
    mdiFilterOutline,
    mdiPaletteOutline,
    mdiTuneVariant,
    mdiViewDashboardOutline,
    mdiDeleteClock,
    mdiBrightness4,
    mdiBrightness7,
    mdiBrush,
    mdiCalendar,
    mdiCheck,
    mdiCheckCircle,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiChevronUp,
    mdiClose,
    mdiCloseCircle,
    mdiCloudDownload,
    mdiCloudUpload,
    mdiContentCopy,
    mdiDelete,
    mdiDeleteOutline,
    mdiFileDocumentOutline,
    mdiAlertCircleOutline,
    mdiAlertOctagon,
    mdiArrowExpand,
    mdiDownload,
    mdiEmailFast,
    mdiAccountGroup,
    mdiFlask,
    mdiFitToScreen,
    mdiHelpCircleOutline,
    mdiImage,
    mdiImageMultiple,
    mdiImageSearch,
    mdiInformation,
    mdiChartLine,
    mdiLaunch,
    mdiMapMarker,
    mdiMagnify,
    mdiMinus,
    mdiNoteText,
    mdiNumeric1Circle,
    mdiNumeric2Circle,
    mdiNumeric3Circle,
    mdiNumeric4Circle,
    mdiOpenInNew,
    mdiAccount,
    mdiDomain,
    mdiShieldAccount,
    mdiShieldCheck,
    mdiPlay,
    mdiPlayBoxMultiple,
    mdiCardText,
    mdiCog,
    mdiPencil,
    mdiPresentationPlay,
    mdiPuzzle,
    mdiRefresh,
    mdiRoutes,
    mdiSecurity,
    mdiShareVariant,
    mdiSort,
    mdiStar,
    mdiSync,
    mdiThumbDown,
    mdiThumbUp,
    mdiTimer,
    mdiViewDashboard,
    mdiViewGrid,
    mdiViewList,
    mdiWalk,
    mdiWeatherNight,
    mdiWeb,
} from '@mdi/js'

// Centralized icon registry: maps alias names to @mdi/js SVG paths.
// Usage in templates: <v-icon>$aliasName</v-icon> or icon="$aliasName"
export const appIcons = {
    // Navigation & Layout
    dashboard: mdiViewDashboard,
    navDashboard: mdiViewDashboardOutline,
    navCampaign: mdiBullhornOutline,
    navCreative: mdiPaletteOutline,
    navProfile: mdiTuneVariant,
    navCondition: mdiFilterOutline,
    viewGrid: mdiViewGrid,
    viewList: mdiViewList,
    chevronRight: mdiChevronRight,
    chevronLeft: mdiChevronLeft,
    expandMore: mdiChevronDown,
    keyboardArrowDown: mdiChevronDown,
    keyboardArrowUp: mdiChevronUp,
    arrowBack: mdiArrowLeft,

    // Actions
    add: mdiPlus,
    edit: mdiPencil,
    delete: mdiDelete,
    deleteOutline: mdiDeleteOutline,
    close: mdiClose,
    done: mdiCheck,
    remove: mdiMinus,
    refresh: mdiRefresh,
    sync: mdiSync,
    launch: mdiLaunch,
    openInNew: mdiOpenInNew,
    openInFull: mdiArrowExpand,
    share: mdiShareVariant,
    fileCopy: mdiContentCopy,
    getApp: mdiDownload,
    search: mdiMagnify,
    sort: mdiSort,
    settings: mdiCog,

    // Indicators
    star: mdiStar,

    // Content & Status
    info: mdiInformation,
    errorOutline: mdiAlertCircleOutline,
    helpOutline: mdiHelpCircleOutline,
    checkCircle: mdiCheckCircle,
    closeCircle: mdiCloseCircle,
    report: mdiAlertOctagon,
    insights: mdiChartLine,

    // People
    person: mdiAccount,
    accountCircle: mdiAccountCircle,
    group: mdiAccountGroup,
    directionsWalk: mdiWalk,
    domain: mdiDomain,
    shieldAccount: mdiShieldAccount,
    shieldCheck: mdiShieldCheck,

    // Files & Cloud
    cloudUpload: mdiCloudUpload,
    cloudDownload: mdiCloudDownload,
    description: mdiFileDocumentOutline,
    docs: mdiBookOpenPageVariant,

    // Domain-specific
    featuredPlayList: mdiCardText,
    photoLibrary: mdiImageMultiple,
    photo: mdiImage,
    subscriptions: mdiPlayBoxMultiple,
    slideshow: mdiPresentationPlay,
    science: mdiFlask,
    imageSearch: mdiImageSearch,

    // Campaign/Creative status
    brush: mdiBrush,
    check: mdiCheck,
    playArrow: mdiPlay,
    outgoingMail: mdiEmailFast,

    // Condition
    api: mdiApi,
    alarm: mdiAlarm,
    autoDelete: mdiDeleteClock,
    extension: mdiPuzzle,
    http: mdiWeb,
    route: mdiRoutes,
    security: mdiSecurity,

    // Form
    event: mdiCalendar,
    notes: mdiNoteText,

    // Theme & Display
    darkMode: mdiWeatherNight,
    brightness4: mdiBrightness4,
    brightness7: mdiBrightness7,
    aspectRatio: mdiAspectRatio,
    fitScreen: mdiFitToScreen,
    timer: mdiTimer,
    language: mdiWeb,

    // Location
    place: mdiMapMarker,

    // Approval
    thumbUp: mdiThumbUp,
    thumbDown: mdiThumbDown,

    // Number labels
    looksOne: mdiNumeric1Circle,
    looksTwo: mdiNumeric2Circle,
    looks3: mdiNumeric3Circle,
    looks4: mdiNumeric4Circle,
}
